module.exports = false;


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 3